import TimeseriesBarChart from "./TimeseriesBarChart";
import { formatDate } from "./MonthDrilldown";

const activityDrilldownConfig = {
    itemsKey: "activities",
    countKey: "pairsWithActivity",
    summary: "completed at least one activity",
    activeTabLabel: "Completed",
    inactiveTabLabel: "No activity",
    itemsColumn: {
        label: "Completed activities",
        width: "2fr",
        render: (pair) => (
            <div>
                {pair.activities.map((a) => (
                    <p key={a.id}>
                        {a.title}{" "}
                        <span className="card-label neutral">
                            · {a.chapterTitle} · {formatDate(a.completedAt)}
                        </span>
                    </p>
                ))}
            </div>
        ),
    },
};

export default function ActivitiesChart({ programId }) {
    return (
        <TimeseriesBarChart
            programId={programId}
            endpoint="activities"
            dataKey="rateOfCompletedActivities"
            seriesName="Completed Activities Rate"
            drilldownConfig={activityDrilldownConfig}
        />
    );
}
